import type { PreProcessor } from 'api/requestUtils'
import { appendParams } from 'api/requestUtils'

export default function brandLoader(brand: string): PreProcessor {
  return (params) => {
    const { path, options } = params

    if (
      options.excludeBrand ||
      path.includes('without_brand=1') ||
      path.includes('/api/trips') ||
      path.includes('/api/search/place/v1/places') ||
      path.includes('rate-plans/surcharge-dates/margin')
    ) {
      return params
    }

    appendParams({
      key: 'brand',
      value: brand,
    }, params)
    return params
  }
}
